import { RouterModule } from '@angular/router';
import { RunService } from './services/service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ApplicationsComponent } from './components/applications/applications.component';
import { ApplicationDetailsComponent } from './components/application-details/application-details.component';
import { QuestionTextComponent } from './components/question-text/question-text.component';
import { QuestionDataComponent } from './components/question-data/question-data.component';
import { AacrHeaderComponent } from './components/aacr-header/aacr-header.component';
import { BusyIndicatorComponent } from './components/busy-indicator/busy-indicator.component';
import { HomeComponent } from './home/home.component';
import { LoginModule } from '@aacr/shared';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    QuestionTextComponent,
    QuestionDataComponent,
    AacrHeaderComponent,
    BusyIndicatorComponent,
    ApplicationsComponent,
    ApplicationDetailsComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    LoginModule.forRoot({
      forgotPasswordUrl: `${environment.drupalSiteUrl}/reset-password`,
      createAccountUrl: `${environment.drupalSiteUrl}/sign-up`,
      apiRoot: environment.apiRoot,
      drupalSiteUrl: environment.drupalSiteUrl
    }),
  ],
  providers: [RunService, HttpClient],
  bootstrap: [AppComponent]
})
export class AppModule { }
